"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adjustUserMoney = adjustUserMoney;
exports.captchaApi = captchaApi;
exports.captchaconfigApi = captchaconfigApi;
exports.controlSingleUserStatus = controlSingleUserStatus;
exports.controlUser = controlUser;
exports.deletUserAccountBill = deletUserAccountBill;
exports.deleteIdAuth = deleteIdAuth;
exports.deleteInvestment = deleteInvestment;
exports.deleteRecharge = deleteRecharge;
exports.deleteUser = deleteUser;
exports.deleteUserBank = deleteUserBank;
exports.deleteUserOperateLog = deleteUserOperateLog;
exports.deleteWithdraw = deleteWithdraw;
exports.foundsApi = foundsApi;
exports.getAccountBillList = getAccountBillList;
exports.getIdAuthInfo = getIdAuthInfo;
exports.getIdAuthLogList = getIdAuthLogList;
exports.getInfo = getInfo;
exports.getInvestmentList = getInvestmentList;
exports.getInvestmentOrderList = getInvestmentOrderList;
exports.getInvestmentOrderStatistics = getInvestmentOrderStatistics;
exports.getLangValueList = getLangValueList;
exports.getLoginLogList = getLoginLogList;
exports.getLoginPicApi = getLoginPicApi;
exports.getRechargeInfo = getRechargeInfo;
exports.getRechargeList = getRechargeList;
exports.getSpreadUserStatisticData = getSpreadUserStatisticData;
exports.getUserBankList = getUserBankList;
exports.getUserInfo = getUserInfo;
exports.getUserListByAccount = getUserListByAccount;
exports.getWithdrawInfo = getWithdrawInfo;
exports.getWithdrawList = getWithdrawList;
exports.groupDeleteApi = groupDeleteApi;
exports.groupInfoApi = groupInfoApi;
exports.groupListApi = groupListApi;
exports.groupPiApi = groupPiApi;
exports.groupSaveApi = groupSaveApi;
exports.groupUpdateApi = groupUpdateApi;
exports.infobyconditionApi = infobyconditionApi;
exports.levelDeleteApi = levelDeleteApi;
exports.levelInfoApi = levelInfoApi;
exports.levelListApi = levelListApi;
exports.levelSaveApi = levelSaveApi;
exports.levelUpdateApi = levelUpdateApi;
exports.levelUseApi = levelUseApi;
exports.login = login;
exports.logout = logout;
exports.outUserLogin = outUserLogin;
exports.prolongMoneyInvestmentOrder = prolongMoneyInvestmentOrder;
exports.reviewIdAuth = reviewIdAuth;
exports.reviewRechargeInfo = reviewRechargeInfo;
exports.reviewWithdrawInfo = reviewWithdrawInfo;
exports.saveInvestment = saveInvestment;
exports.settleMoneyInvestmentOrder = settleMoneyInvestmentOrder;
exports.tagDeleteApi = tagDeleteApi;
exports.tagInfoApi = tagInfoApi;
exports.tagListApi = tagListApi;
exports.tagPiApi = tagPiApi;
exports.tagSaveApi = tagSaveApi;
exports.tagUpdateApi = tagUpdateApi;
exports.topdetailApi = topdetailApi;
exports.updatePhoneApi = updatePhoneApi;
exports.updateSpreadApi = updateSpreadApi;
exports.updateUserBank = updateUserBank;
exports.userDeleteApi = userDeleteApi;
exports.userInfoApi = userInfoApi;
exports.userLevelUpdateApi = userLevelUpdateApi;
exports.userListApi = userListApi;
exports.userUpdateApi = userUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function login(data) {
  return (0, _request.default)({
    url: '/admin/login',
    method: 'post',
    data: data
  });
}
function getInfo(token) {
  return (0, _request.default)({
    // url: '/admin/getAdminInfoByToken',
    method: 'get',
    params: {
      token: token
    }
  });
}
function logout() {
  return (0, _request.default)({
    url: '/admin/logout',
    method: 'get'
  });
}

/**
 * 会员管理 列表
 * @param pram
 */
function userListApi(params) {
  return (0, _request.default)({
    url: "/admin/user/getUserList",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 修改
 * @param pram
 */
function userUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/user/saveUser",
    method: 'post',
    data: data
  });
}

/**
 * 会员管理等级 修改
 * @param pram
 */
function userLevelUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/user/update/level",
    method: 'post',
    data: data
  });
}

/**
 * 会员管理 详情
 * @param pram
 */
function userInfoApi(params) {
  return (0, _request.default)({
    url: "/admin/user/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 账户详情
 * @param pram
 */
function infobyconditionApi(params) {
  return (0, _request.default)({
    url: "/admin/user/infobycondition",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 账户详情top数据
 * @param pram
 */
function topdetailApi(params) {
  return (0, _request.default)({
    url: "/admin/user/topdetail",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 批量设置分组
 * @param pram
 */
function groupPiApi(params) {
  return (0, _request.default)({
    url: "/admin/user/group",
    method: 'post',
    params: params
  });
}

/**
 * 会员管理 批量设置标签
 * @param pram
 */
function tagPiApi(params) {
  return (0, _request.default)({
    url: "/admin/user/tag",
    method: 'post',
    params: params
  });
}

/**
 * 会员管理 积分余额
 * @param pram
 */
function foundsApi(params) {
  return (0, _request.default)({
    url: "/admin/user/operate/founds",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 删除
 * @param pram
 */
function userDeleteApi(params) {
  return (0, _request.default)({
    url: "/admin/user/delete",
    method: 'get',
    params: params
  });
}

/**
 * 会员等级 列表
 * @param pram
 */
function levelListApi() {
  return (0, _request.default)({
    url: "/admin/level/getList",
    method: 'get'
  });
}

/**
 * 会员等级 新增
 * @param pram
 */
function levelSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/level/saveLevel",
    method: 'post',
    data: data
  });
}

/**
 * 会员等级 编辑
 *  @param pram
 */
function levelUpdateApi(params, data) {
  return (0, _request.default)({
    url: "/admin/level/saveLevel",
    method: 'post',
    // params,
    data: data
  });
}

/**
 * 会员等级 详情
 * @param pram
 */
function levelInfoApi(params) {
  return (0, _request.default)({
    url: "/admin/system/user/level/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员等级 删除
 * @param pram
 */
function levelDeleteApi(data) {
  return (0, _request.default)({
    url: "/admin/level/deleteLevel",
    method: 'post',
    data: data
  });
}

/**
 * 会员等级 是否显示
 * @param pram
 */
function levelUseApi(data) {
  return (0, _request.default)({
    url: "/admin/system/user/level/use",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 列表
 * @param pram
 */
function tagListApi(params) {
  return (0, _request.default)({
    url: "/admin/user/tag/list",
    method: 'get',
    params: params
  });
}

/**
 * 会员标签 新增
 * @param pram
 */
function tagSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/user/tag/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 编辑
 * @param pram
 */
function tagUpdateApi(params, data) {
  return (0, _request.default)({
    url: "/admin/user/tag/update",
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * 会员标签 详情
 * @param pram
 */
function tagInfoApi(params) {
  return (0, _request.default)({
    url: "/admin/user/tag/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员标签 删除
 * @param pram
 */
function tagDeleteApi(params) {
  return (0, _request.default)({
    url: "/admin/user/tag/delete",
    method: 'get',
    params: params
  });
}

/**
 * 会员分组 列表
 * @param pram
 */
function groupListApi(params) {
  return (0, _request.default)({
    url: "/admin/user/group/list",
    method: 'get',
    params: params
  });
}

/**
 * 会员分组 新增
 * @param pram
 */
function groupSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/user/group/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员分组 编辑
 * @param pram
 */
function groupUpdateApi(params, data) {
  return (0, _request.default)({
    url: "/admin/user/group/update",
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * 会员分组 详情
 * @param pram
 */
function groupInfoApi(params) {
  return (0, _request.default)({
    url: "/admin/user/group/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员分组 删除
 * @param pram
 */
function groupDeleteApi(params) {
  return (0, _request.default)({
    url: "/admin/user/group/delete",
    method: 'get',
    params: params
  });
}

/**
 *获取登录页图片
 */
function getLoginPicApi() {
  return (0, _request.default)({
    url: "/admin/getLoginPic",
    method: 'get'
  });
}

/**
 * @description 验证码
 */
function captchaApi() {
  return (0, _request.default)({
    url: "/admin/validate/code/get",
    method: 'get'
  });
}

/**
 * @description 修改上级推广人
 */
function updateSpreadApi(data) {
  return (0, _request.default)({
    url: "/admin/user/update/spread",
    method: 'post',
    data: data
  });
}

/**
 * @description 修改手机号
 */
function updatePhoneApi(params) {
  return (0, _request.default)({
    url: "/admin/user/update/phone",
    method: 'get',
    params: params
  });
}

/**
 * 查询是否需要开启图形验证码
 * @returns {*}
 */
function captchaconfigApi() {
  return (0, _request.default)({
    url: "/admin/validate/code/getcaptchaconfig",
    method: 'get'
  });
}

// 用户实名开始

// 用户实名列表
function getIdAuthLogList(params) {
  return (0, _request.default)({
    url: "/admin/user/idauth/getIdAuthLogList",
    method: 'get',
    params: params
  });
}

// 获取实名详情
function getIdAuthInfo(params) {
  return (0, _request.default)({
    url: "/admin/user/idauth/getIdAuthInfo",
    method: 'get',
    params: params
  });
}

// 审核
function reviewIdAuth(data) {
  return (0, _request.default)({
    url: "/admin/user/idauth/reviewIdAuth",
    method: 'post',
    data: data
  });
}

// 删除实名信息
function deleteIdAuth(data) {
  return (0, _request.default)({
    url: "/admin/user/idauth/deleteIdAuth",
    method: 'post',
    data: data
  });
}

// 获取流水信息列表
function getAccountBillList(params) {
  return (0, _request.default)({
    url: "/admin/user/getAccountBillList",
    method: 'get',
    params: params
  });
}

// 删除流水记录
function deletUserAccountBill(data) {
  return (0, _request.default)({
    url: "/admin/user/deleteUserAccountBill",
    method: 'post',
    data: data
  });
}

// 获取充值记录
function getRechargeList(params) {
  return (0, _request.default)({
    url: "/admin/user/recharge/getRechargeList",
    method: 'get',
    params: params
  });
}

// 删除充值记录
function deleteRecharge(data) {
  return (0, _request.default)({
    url: "/admin/user/recharge/deleteRecharge",
    method: 'post',
    data: data
  });
}

// 提交审核
function reviewRechargeInfo(data) {
  return (0, _request.default)({
    url: "/admin/user/recharge/reviewRechargeInfo",
    method: 'post',
    data: data
  });
}

// 获取充值详情
function getRechargeInfo(params) {
  return (0, _request.default)({
    url: "/admin/user/recharge/getRechargeInfo",
    method: 'get',
    params: params
  });
}

// 获取提现列表
function getWithdrawList(params) {
  return (0, _request.default)({
    url: "/admin/user/withdraw/getWithdrawList",
    method: 'get',
    params: params
  });
}

// 获取提现详情
function getWithdrawInfo(params) {
  return (0, _request.default)({
    url: "/admin/user/withdraw/getWithdrawInfo",
    method: 'get',
    params: params
  });
}

// 提交审核提现
function reviewWithdrawInfo(data) {
  return (0, _request.default)({
    url: "/admin/user/withdraw/reviewWithdrawInfo",
    method: 'post',
    data: data
  });
}

// 删除审核提现
function deleteWithdraw(data) {
  return (0, _request.default)({
    url: "/admin/user/withdraw/deleteWithdraw",
    method: 'post',
    data: data
  });
}

// 获取余额宝列表
function getInvestmentList(params) {
  return (0, _request.default)({
    url: "/admin/user/getInvestmentList",
    method: 'get',
    params: params
  });
}

// 保存余额宝产品
function saveInvestment(data) {
  return (0, _request.default)({
    url: "/admin/user/saveInvestment",
    method: 'post',
    data: data
  });
}

// 删除余额宝
function deleteInvestment(data) {
  return (0, _request.default)({
    url: "/admin/user/deleteInvestment",
    method: 'post',
    data: data
  });
}

// 获取余额宝订单列表
function getInvestmentOrderList(params) {
  return (0, _request.default)({
    url: "/admin/user/getInvestmentOrderList",
    method: 'get',
    params: params
  });
}

// 获取余额宝总计数据
function getInvestmentOrderStatistics(params) {
  return (0, _request.default)({
    url: "/admin/user/getInvestmentOrderStatistics",
    method: 'get',
    params: params
  });
}

// 获取业务多语言
function getLangValueList(params) {
  return (0, _request.default)({
    url: '/admin/system/getLangValueList',
    method: 'get',
    params: params
  });
}

// 获取用户详情
function getUserInfo(params) {
  return (0, _request.default)({
    url: "/admin/user/getUserInfo",
    method: 'get',
    params: params
  });
}
function deleteUser(data) {
  return (0, _request.default)({
    url: '/admin/user/deleteUser',
    method: 'post',
    data: data
  });
}
function outUserLogin(data) {
  return (0, _request.default)({
    url: '/admin/user/outUserLogin',
    method: 'post',
    data: data
  });
}

// 获取用户钱包信息列表
function getUserBankList(params) {
  return (0, _request.default)({
    url: "/admin/user/getUserBankList",
    method: 'get',
    params: params
  });
}
function deleteUserBank(data) {
  return (0, _request.default)({
    url: '/admin/user/deleteUserBank',
    method: 'post',
    data: data
  });
}

// 登录记录列表
function getLoginLogList(params) {
  return (0, _request.default)({
    url: "/admin/user/getLoginLogList",
    method: 'get',
    params: params
  });
}

// 删除登录记录
function deleteUserOperateLog(data) {
  return (0, _request.default)({
    url: '/admin/user/deleteUserOperateLog',
    method: 'post',
    data: data
  });
}

// 结算余额宝订单

function settleMoneyInvestmentOrder(data) {
  return (0, _request.default)({
    url: '/admin/user/investment/settleMoneyInvestmentOrder',
    method: 'post',
    data: data
  });
}

// 续期订单
function prolongMoneyInvestmentOrder(data) {
  return (0, _request.default)({
    url: '/admin/user/investment/prolongMoneyInvestmentOrder',
    method: 'post',
    data: data
  });
}

// 获取会员关系表列表
function getUserListByAccount(params) {
  return (0, _request.default)({
    url: "/admin/user/getUserListByAccount",
    method: 'get',
    params: params
  });
}

/**
 * 调整用户金额
 *  @param pram
 */
function adjustUserMoney(data) {
  return (0, _request.default)({
    url: "/admin/user/adjustUserMoney",
    method: 'post',
    data: data
  });
}

/**
 * 修改状态
 *  @param pram
 */
function controlSingleUserStatus(data) {
  return (0, _request.default)({
    url: "/admin/user/controlSingleUserStatus",
    method: 'post',
    data: data
  });
}

// 获取代理报表
function getSpreadUserStatisticData(params) {
  return (0, _request.default)({
    url: "/admin/user/spread/getSpreadUserStatisticData",
    method: 'get',
    params: params
  });
}

// 修改提款信息
function updateUserBank(data) {
  return (0, _request.default)({
    url: "/admin/user/updateUserBank",
    method: 'post',
    data: data
  });
}

// 控制用户
function controlUser(data) {
  return (0, _request.default)({
    url: "/admin/user/controlUser",
    method: 'post',
    data: data
  });
}